<template>
  <PriceList v-bind="priceListProps">
    <template v-if="numberOfPlays" #default>
      <HighFrequencyGamePriceBreakdownList v-bind="{ currentPrice }" />
    </template>
  </PriceList>
</template>

<script lang="ts" setup>
import Money from '~~/models/Money'

const { currentPrice } = useHighFrequencyGame()

const numberOfPlays = computed(() => currentPrice.value?.numberOfDraws ?? 0)

const priceListProps = computed(() => ({
  chargeTotal: new Money(currentPrice.value?.chargeTotal),
  convenienceFee: new Money(currentPrice.value?.feeTotal),
  salesTax: salesTax.value,
  showSalesTax: (salesTax.value.value ?? 0) > 0,
}))

const salesTax = computed(() => new Money(currentPrice.value?.salesTax))
</script>
